import BrowserFeaturesPage from 'components/features-page/BrowserFeaturesPage'
import type { PageProps } from 'gatsby'

export default function Firefox({ location }: PageProps): JSX.Element {
  return <BrowserFeaturesPage path={location.pathname} />
}
